import { render, staticRenderFns } from "./VehicleCarousel.vue?vue&type=template&id=926c1858&"
import script from "./VehicleCarousel.vue?vue&type=script&lang=js&"
export * from "./VehicleCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports